import { render, staticRenderFns } from "./CheckinDetail.vue?vue&type=template&id=22f5e2ec&scoped=true&"
import script from "./CheckinDetail.vue?vue&type=script&lang=js&"
export * from "./CheckinDetail.vue?vue&type=script&lang=js&"
import style0 from "./CheckinDetail.vue?vue&type=style&index=0&id=22f5e2ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f5e2ec",
  null
  
)

export default component.exports